import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4df5886c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-container" }
const _hoisted_2 = { class: "d-flex container-tabs" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dashboard-tabs" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dashboard-item-header" }, "Faturamento de Gestão de Marcas")
], -1))
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { class: "btns-container" }
const _hoisted_6 = { class: "dashboard-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardTabsMobile = _resolveComponent("DashboardTabsMobile")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, _toDisplayString(_ctx.currentFormattedDate), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_DashboardTabsMobile)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_router_view)
    ])
  ]))
}